import { render } from "./zoom-out.vue?vue&type=template&id=2dae6ca7"
const script = {}
script.render = render

export default script